import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Router, RoutesRecognized, NavigationEnd, Event} from '@angular/router';
import {filter, pairwise } from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingTrackerService {
  private previousUrl: string;
  private currentUrl: string;
  public breadcrumbString = '';

  public isCurrentUrl = new BehaviorSubject<string>(undefined);
  public isPreviousUrl = new BehaviorSubject<string>(undefined);

  constructor(private router: Router) {

    // NOTE: Track pairs of *completed* navigations (NavigationEnd), not RoutesRecognized.
    // RoutesRecognized fires for every route that gets recognized, including ones that are
    // immediately rejected by a route guard (e.g. PermissionGuard) and redirected elsewhere
    // (e.g. /common/not-authorized-page). If we tracked RoutesRecognized here, "previousUrl"
    // would end up being the *blocked* route itself (since its RoutesRecognized event fired
    // right before the guard's redirect), causing the Not Authorized page's "Back" button to
    // navigate right back into the same blocked route and bounce back to Not Authorized again.
    // NavigationEnd only fires for navigations that actually complete, so pairing those gives
    // the real last-successful-page the user was on before landing on the current page.
    this.router.events
      .pipe(filter((evt: any) => evt instanceof NavigationEnd), pairwise())
      .subscribe((events: NavigationEnd[]) => {
        this.previousUrl = events[0].urlAfterRedirects;
        this.currentUrl = events[1].urlAfterRedirects;

        this.isPreviousUrl.next(events[0].urlAfterRedirects);
        this.isCurrentUrl.next(events[1].urlAfterRedirects);

        // console.log('previous url', this.previousUrl);
        // console.log('current url', this.currentUrl);
      });

    router.events.subscribe((event: Event) => {
      if (event instanceof RoutesRecognized) {
        // * RoutesRecognized: When the router parses the URL and the routes are recognized.
        // ! This is the earliest event in the navigation lifecycle that you can begin to update the breadcrumbs
        // console.log('route from event catch 1st: ' + this.findLastFirstChild(event.state.root));
        // console.log('route from event catch 2nd: ' + this.findLastFirstChild(event.state.root));
        // this.breadcrumbString = this.getBreadcrumbs(this.findLastFirstChild(event.state.root));
        // console.log('bread crumb string: ' + this.breadcrumbString);

      }
    });
  }

  private findLastFirstChild(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
    return snapshot.firstChild
      ? this.findLastFirstChild(snapshot.firstChild)
      : snapshot;
  }

  private getBreadcrumbs(snapshot: ActivatedRouteSnapshot): string {
    const breadcrumbs: string[] = [];
    // * At the root url, url[0] will not exist
    if (snapshot.url[0]?.path) {
      breadcrumbs.push(snapshot.url[0]?.path);
    }
    // * snapshot.params will be an object with properties that match the route params used for your current route
    // * Ex: snapshot.params = {class: 'English', chapter: '7', assignment: '4'}
    for (const [key, value] of Object.entries(snapshot.params)) {
      breadcrumbs.push(`${key.slice(0, 1).toUpperCase() + key.slice(1)}: ${value.slice(0, 1).toUpperCase() + value.slice(1)}`);
      // Breadcrumb template = "Key: Value"
    }
    return breadcrumbs.join(' > ');
    // Full breadcrumbs output = "Root > Key: Value > Key: Value > ..."
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  //
  // public getCurrentUrl() {
  //   return this.currentUrl;
  // }
}
